import { useEffect, useState, type FormEvent } from 'react';
import { MessageSquareText, Save } from 'lucide-react';
import type { FamilyProfile } from '../types';

interface FamilyToolsProps {
  ownProfile: FamilyProfile;
  isBusy: boolean;
  onSaveNote: (noteText: string) => Promise<void>;
}

export function FamilyTools({
  ownProfile,
  isBusy,
  onSaveNote,
}: FamilyToolsProps) {
  const [noteText, setNoteText] = useState(ownProfile.note_text || '');

  useEffect(() => setNoteText(ownProfile.note_text || ''), [ownProfile.note_text]);

  async function handleSaveNote(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onSaveNote(noteText.trim());
  }

  return (
    <section className="family-tools" aria-labelledby="family-tools-title">
      <div className="section-heading">
        <p className="eyebrow">Extra di famiglia</p>
        <h2 id="family-tools-title">Altro</h2>
      </div>

      <article className="tool-card">
        <div className="tool-card__heading">
          <span className="tool-card__icon"><MessageSquareText size={21} aria-hidden="true" /></span>
          <div><h3>La mia nota rapida</h3><p>Comparirà accanto al tuo nome.</p></div>
        </div>
        <form className="quick-note-form" onSubmit={handleSaveNote}>
          <label className="field">
            <span>Nota</span>
            <input
              value={noteText}
              maxLength={80}
              placeholder="Es. Sono con Jessica"
              onChange={(event) => setNoteText(event.target.value)}
            />
          </label>
          <button className="button button--secondary" type="submit" disabled={isBusy || noteText.trim() === (ownProfile.note_text || '')}>
            <Save size={18} aria-hidden="true" /> Salva nota
          </button>
        </form>
      </article>

    </section>
  );
}
